import { connect } from 'react-redux';
import { togglePinGroup, unrecommendGroup } from '../../redux/actions';
var mapDispatchToProps = {
    togglePinGroup: togglePinGroup,
    unrecommendGroup: unrecommendGroup,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=NetworkBarGroupLink.container.js.map